import {useEffect, useState} from "react";
import {BottomSheet} from "../layout";
import {BaseSlide} from "./BaseSlide";
import DawCool from "./assets/daw-cool.png";
import DawMoney from "./assets/daw-money.png";
import DawNope from "./assets/daw-nope.png";
import {ProgressBar, YStack, Slider, Button} from "@chayka/ui";

interface FinesAndBalanceBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const SLIDE_PROGRESS_CLASS = ["w-1/3", "w-2/3", "w-full"];

const SLIDES = [
  {
    title: "Баланс",
    image: DawMoney,
    description:
      "Баланс – это состояние вашего личного счета в нашей системе. Он может быть как положительным, так и отрицательным. Баланс можно пополнять на любую сумму и списывать с него средства за любые услуги студии.",
  },
  {
    title: "Штрафы",
    image: DawNope,
    description:
      "Штрафы назначаются в том случае, если отмена брони произошла менее, чем за 48 часов до начала момента брони. До тех пор, пока штраф не погашен, создать новую бронь невозможно.",
  },
  {
    title: "В чём разница?",
    image: DawCool,
    description: "Вот и вся разница! Всё просто, не так ли?",
  },
];

export const FinesAndBalanceBottomSheet: React.FC<FinesAndBalanceBottomSheetProps> = ({
  isOpen,
  onClose,
}) => {
  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => {
        setSlideIndex(0);
      }, 1000);
    }
  }, [isOpen]);

  return (
    <BottomSheet fullHeight isOpen={isOpen} onClose={onClose}>
      <YStack className="h-full">
        <YStack className="gap-3 justify-center items-center sticky top-0 z-1 pb-3 -mb-3 bg-background">
          <h1 className="text-center text-xl font-bold">{SLIDES[slideIndex]?.title}</h1>
          <ProgressBar progressClass={SLIDE_PROGRESS_CLASS[slideIndex] ?? ""} />
        </YStack>
        <Slider
          items={SLIDES}
          renderItem={({item}) => (
            <BaseSlide imageSrc={item.image} description={item.description} />
          )}
          onIndexChange={setSlideIndex}
          className="flex flex-1 h-full"
          shouldLoop={false}
        />
        <Button
          onClick={() =>
            slideIndex < SLIDES.length - 1
              ? setSlideIndex((prev) => (prev < SLIDES.length - 1 ? prev + 1 : prev))
              : onClose()
          }
          className="self-stretch"
        >
          {slideIndex === SLIDES.length - 1 ? "Ясно, спасибо!" : "Далее"}
        </Button>
      </YStack>
    </BottomSheet>
  );
};
